import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export const MD_COMPONENTS = {
  h1: (p) => <h1 className="font-sans font-bold uppercase text-2xl text-zinc-50 mt-8 mb-4 first:mt-0" {...p} />,
  h2: (p) => <h2 className="font-sans font-bold uppercase text-lg text-zinc-100 mt-8 mb-3 border-b border-white/10 pb-2" {...p} />,
  h3: (p) => <h3 className="font-sans font-semibold uppercase text-base text-zinc-200 mt-6 mb-2" {...p} />,
  p: (p) => <p className="font-mono text-sm text-zinc-300 leading-relaxed mb-4" {...p} />,
  li: (p) => <li className="font-mono text-sm text-zinc-300 leading-relaxed ml-5 mb-1.5 list-disc" {...p} />,
  code: ({ className, children, ...p }) => {
    const isBlock = String(children).includes("\n") || (className || "").startsWith("language-");
    return isBlock
      ? <code className="block font-mono text-[13px] text-zinc-200 bg-black/60 border border-white/10 p-4 my-4 overflow-x-auto whitespace-pre" {...p}>{children}</code>
      : <code className="font-mono text-[13px] text-nc-orange bg-nc-orange/10 px-1.5 py-0.5" {...p}>{children}</code>;
  },
  pre: (p) => <pre className="my-4" {...p} />,
  a: (p) => <a className="text-nc-blue underline hover:text-nc-orange transition-colors" target="_blank" rel="noopener noreferrer" {...p} />,
  table: (p) => <table className="w-full border border-white/10 my-4 font-mono text-xs" {...p} />,
  th: (p) => <th className="border-b border-white/20 bg-white/5 px-3 py-2 text-left text-zinc-300 uppercase tracking-wider" {...p} />,
  td: (p) => <td className="border-b border-white/10 px-3 py-2 text-zinc-400" {...p} />,
  blockquote: (p) => <blockquote className="border-l-2 border-nc-blue pl-4 my-4 text-zinc-400 italic" {...p} />,
  img: ({ src, alt }) => (
    <span className="block my-5 border border-white/10 bg-black/40 p-2">
      <img src={src} alt={alt || "figure"} className="max-w-full h-auto mx-auto" loading="lazy" />
      {alt && <span className="block font-mono text-[9px] tracking-[0.2em] uppercase text-zinc-600 text-center mt-2">{alt}</span>}
    </span>
  ),
};

export function Markdown({ children }) {
  return <ReactMarkdown remarkPlugins={[remarkGfm]} components={MD_COMPONENTS}>{children}</ReactMarkdown>;
}
